import { render, staticRenderFns } from "./TopUpComp.vue?vue&type=template&id=1886b121&scoped=true"
import script from "./TopUpComp.vue?vue&type=script&lang=ts"
export * from "./TopUpComp.vue?vue&type=script&lang=ts"
import style0 from "./TopUpComp.vue?vue&type=style&index=0&id=1886b121&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1886b121",
  null
  
)

export default component.exports